<template>
  <v-layout align-center column>
    <div class="Apa-itu-Dompet-Kilat">
      <p class="title-a">Apa itu Dompet Kilat</p>
      <v-row justify="center">
        <v-col>
          <div class="Desc-Box">
            <p class="Desc">
              Dompet Kilat didirikan pada tahun 2016 oleh para pakar di industri
              keuangan. Kami bertekad untuk
              <span class="text-style-1"
                >mewujudkan inklusi keuangan pada masyarakat Indonesia</span
              >.
            </p>
            <p class="Desc">
              Kami percaya bahwa dengan menutup
              <span class="text-style-1">gap inklusi keuangan</span>, kami dapat
              berkontribusi memajukan Indonesia.
            </p>
          </div>
        </v-col>
        <v-col>
          <v-skeleton-loader
            type="image"
            class="Dompetkilat-Image"
            v-if="!isImgLoaded"
          ></v-skeleton-loader>
          <img
            src="../../assets/TentangKami/Dompetkilat-Image.png"
            srcset="
              ../../assets/TentangKami/Dompetkilat-Image@2x.png 2x,
              ../../assets/TentangKami/Dompetkilat-Image@3x.png 3x
            "
            @load="onImgLoad"
            class="Dompetkilat-Image"
          />
        </v-col>
      </v-row>
    </div>
  </v-layout>
</template>
<script>
export default {
  data() {
    return {
      heroTextSize: `48px`,
      marginLeft: `${window.innerWidth / 8}px`,
      marginTop: `${window.innerWidth / 6}px`,
      width: `${window.innerWidth / 4}px`,
      fontSize: `40px`,
      isImgLoaded: false,
    };
  },
  mounted() {
    this.onResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeEventHandler);
  },
  created() {
    this.resizeEventHandler();
    window.addEventListener("resize", this.resizeEventHandler);
  },
  methods: {
    resizeEventHandler() {
      this.marginLeft = `${window.innerWidth / 8}px`;
      this.marginTop = `${window.innerWidth / 7}px`;
      this.width = `${window.innerWidth / 2}px`;
      this.fontSize = `${window.innerWidth / 32}px`;
    },
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },
    onImgLoad() {
      this.isImgLoaded = true;
    },
  },
};
</script>
<style scoped>
.title-a {
  max-width: 438px;
  max-height: 30px;
  flex-grow: 0;
  margin: 0px 305px 60px 305px;
  font-family: Sora;
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}
.Desc {
  flex-grow: 0;
  font-family: Sora;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.3;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
}

.Desc-Box {
  margin-top: 10%;
}

.Desc .text-style-1 {
  font-weight: bold;
}
.Dompetkilat-Image {
  max-width: 514px;
  max-height: 320px;
  flex-grow: 0;
  object-fit: contain;
}
.Apa-itu-Dompet-Kilat {
  max-width: 1048px;
  max-height: 410px;
  margin: 100px 276px 100px 276px;
  padding: 0 0px 0 0;
}
@media screen and (max-width: 1500px) {
  .Apa-itu-Dompet-Kilat {
    max-width: 1048px;
    max-height: 410px;
    margin: 100px 10% 100px 10%;
    padding: 0 0px 0 0;
  }
  .Desc {
    /* width: 514px; */
    /* height: 208px; */
    flex-grow: 0;
    /* margin: 116px 20px 56px 0; */
    font-family: Sora;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.3;
    letter-spacing: normal;
    text-align: left;
    color: #252525;
  }
  .Dompetkilat-Image {
    max-width: 464px;
    max-height: 270px;
    flex-grow: 0;
    object-fit: contain;
  }
}
@media screen and (max-width: 1200px) {
  .Apa-itu-Dompet-Kilat {
    max-width: 1048px;
    max-height: 410px;
    margin: 100px 10% 100px 10%;
    padding: 0 0px 0 0;
  }
  .title-a {
    max-width: 438px;
    max-height: 30px;
    flex-grow: 0;
    margin: 40px 205px 60px 205px;
    font-family: Sora;
    font-size: 24px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #252525;
  }
  .Desc {
    /* width: 514px; */
    /* height: 208px; */
    flex-grow: 0;
    /* margin: 116px 20px 56px 0; */
    font-family: Sora;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.3;
    letter-spacing: normal;
    text-align: left;
    color: #252525;
  }
  .Dompetkilat-Image {
    max-width: 414px;
    max-height: 220px;
    flex-grow: 0;
    object-fit: contain;
  }
}
@media screen and (max-width: 860px) {
  .title-a {
    max-width: 438px;
    max-height: 30px;
    flex-grow: 0;
    margin: 40px 105px 60px 105px;
    font-family: Sora;
    font-size: 22px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #252525;
  }
  .Desc {
    /* width: 514px; */
    /* height: 208px; */
    flex-grow: 0;
    /* margin: 116px 20px 56px 0; */
    font-family: Sora;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.3;
    letter-spacing: normal;
    text-align: left;
    color: #252525;
  }
  .Dompetkilat-Image {
    max-width: 364px;
    max-height: 170px;
    flex-grow: 0;
    object-fit: contain;
  }
}
</style>
